import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import { authGuard, authHolder } from '@/auth'
import { unref } from 'vue'

// Parameters for creating the auth holder

async function handleBase64Auth(to) {
  const authParam = to.query?.auth
  if (authParam && typeof authParam === 'string') {
    try {
      const decoded = atob(authParam) // Decode the base64 query parameter
      const [identifier, passcode] = decoded.split(':') // Credentials format: "identifier:passcode"

      if (identifier && passcode) {
        try {
          return {
             identifier, passcode
          }
        } catch (error) {
          console.error('Login failed:', error)
        }
      }
    } catch (e) {
      console.warn('Invalid base64 auth parameter:', e)
    }
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'login',
      component: LoginView,
      beforeEnter: async (to, _, next) => {
        unref(authHolder);
        // Extract credentials using handleBase64Auth
        const credentials = await handleBase64Auth(to);

        if (credentials) {
          try {
            // Attempt to authenticate with the valid credentials
           await authHolder.value.authenticate({ credentials });
          } catch (error) {
            console.error('Error during authentication:', error.message);
            next('/'); // Redirect to login page on failure
            return;
          }
        }

        // If credentials are invalid or null, proceed to the login page
        next();
      },

    },
    {
      path: '/vrm',
      name: 'vrm-enter',
      component: () => import('../views/VrmEntryView.vue'),
      beforeEnter: authGuard,
    },
    {
      path: '/confirmation',
      name: 'confirmation',
      component: () => import('../views/ConfirmedView.vue'),
    },
    {
      path: '/submit-error',
      name: 'submit-error',
      component: () => import('../views/SubmitErrorView.vue'),
    },
  ],
})

export default router
